import React from 'react';
import styled from 'styled-components';

import { Button } from 'components'
import { FaExclamation, FaCheck } from 'react-icons/fa'
import { itemContext } from 'context';

const defaultStyles = {
    backgroundColor: 'var(--secondary-color)',
    margin: 0,
    boxShadow: 'var(--box-shadow)',
    border: '1px solid transparent',
}

const Container = styled.div`
    min-width: 15rem;
    border-radius: 5px;
    background-color: ${props => props.styles.backgroundColor};
    margin-top: 0.2rem;
    box-shadow: ${props => props.styles.boxShadow};
    margin: ${props => props.styles.margin};
    border: ${props => props.styles.border};
`

const Title = styled.div`
    font-weight: bolder;
    font-size: 0.7rem;
    padding: 0.5rem 0 0 0.75rem;
    text-transform: uppercase;
    color: var(--secondary-accent-color);
`

const Wrapper = styled.div`
    border: ${props => `2px solid ${props.selected ? 'var(--focus-color)' : 'transparent'}`};
    border-radius: 5px;
    display: flex;
`

const Row = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: 1rem 3rem 1fr 1rem;
    grid-column-gap: 0.5rem;
    align-items: center;
    padding: 0.5rem 0.5rem;
    background-color: var(--secondary-color);
    border-radius: 5px;
    cursor: pointer;
    :hover{
        filter: brightness(var(--brightness));
    }
`

const Text = styled.div`
    /* font-weight: bold; */
    font-size: 0.8rem;
`

const Icon = styled.div`
    color: ${props => props.color || 'var(--text-color)'};
    display: flex;
    font-size: 0.8rem;
`

const PrioritySelector = props => {
    const {
        title,
        onSelect,
        closeHandler,
        styles,
        onClose,
        selected
    } = props;
    const updatedStyle = Object.assign({}, defaultStyles, styles)
    const [n, setIndex] = React.useState(-1)
    // Refs
    const containerRef = React.useRef()
    const optionsRef = React.useRef([])

    React.useEffect(() => {
        return () => { onClose && onClose() }
    }, [])

    const selectHandler = (event, value) => {
        onSelect(value)
        closeHandler && closeHandler(event)
    }

    let options = Object.keys(itemContext.PRIORITY).map((priority,index) => (
        {
            title: itemContext.PRIORITY_TITLE[priority],
            value: priority,
            icon: <Icon color={itemContext.PRIORITY_COLOR[priority.toUpperCase()]}><FaExclamation/></Icon>,
            styles: {
                backgroundColor: updatedStyle['backgroundColor'], 
                boxShadowColor: 'transparent',
                fontWeight: 'bold',
                margin: '0.1rem 0',
                justifyContent: 'flex-start',
                padding: '0.5rem'
            },
            onSelect: (event) => {selectHandler(event, priority)}
        }
    ))

    return (
        <Container ref={containerRef} styles={updatedStyle}>
            {title && <Title>{title}</Title>}
            {options.map((option,index) => (
                <Wrapper selected={n === index}
                    ref={el => optionsRef.current[index] = el}>
                    <Row onClick={option['onSelect']} styles={option['styles']}>
                        <Icon>{option['icon']}</Icon>
                        <Text>{option['title']}</Text>
                        <span/>
                        {selected && ((option['value'] === selected | (Array.isArray(selected) && selected.includes(option['value'])))) ? <FaCheck style={{ color: 'var(--focus-color)' }}/> : null}
                    </Row>
                </Wrapper>
            ))}    
        </Container>
    )
}

export default PrioritySelector